import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { IFootprintVisibility } from "../../interfaces/i-footprint-visibility";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "lib-property-map-controls",
  templateUrl: "./property-map-controls.component.html",
  styleUrls: ["./property-map-controls.component.scss"],
  standalone: false,
})
export class PropertyMapControlsComponent {
  /** Available measurement system IDs for the radio group. */
  readonly measurementSystems = ViewerConstants.MEASUREMENT_SYSTEMS.IDS;

  /** Current visibility state for the footprint and labels checkboxes. */
  @Input() visibilityValues: IFootprintVisibility = { propertyFootprint: true, labelsFootprint: true };

  /** Currently selected measurement system ID. */
  @Input() measurementSystem: number;

  /** When true, disables the checkboxes (e.g., during discrete map mode). */
  @Input() discreteEnabled = false;

  /** Emits the new measurement system ID when the user changes the unit selection. */
  @Output() measurementSystemChange = new EventEmitter<number>();

  /** Emits the updated visibility object whenever a checkbox changes. */
  @Output() visibilityChange = new EventEmitter<IFootprintVisibility>();

  /**
   * Handles unit radio button change and emits the new system ID.
   * @param event - Radio change event carrying the new value
   */
  onMeasurementSystemChange(event: any): void {
    this.measurementSystemChange.emit(event.value);
  }

  /**
   * Handles visibility checkbox change for a given key and emits the updated state.
   * @param key - Which footprint visibility field changed
   * @param checked - New checked state
   */
  onVisibilityChange(key: keyof IFootprintVisibility, checked: boolean): void {
    this.visibilityChange.emit({ ...this.visibilityValues, [key]: checked });
  }
}
